import { Hints } from "../../assets/classes/Hints";

//Ziel: Auswahl einer zufälligen Frage aus dem questionpoolLine.json, die im bisherigen Spielverlauf noch nicht vorkam

//Aufbau einer Frage mit eindeutiger ID gekennzeichnet
interface Question {
    id: number;
    category: string;
    text: string;
    options: { correct: boolean; text: string }[];
    explanation: string;
    rightAnswer: string[];
    done: boolean;
}

//Alle Felder, die für diese Fragekategorie benötigt werden, werden initialisiert
class QuestionLoaderLine {
    private questionText!: string;
    private options!: string[];
    private explanation!: string;
    private rightAnswer!: string[];
    private questionId!: number;

    constructor() {
        this.questionText = '';
        this.options = [];
        this.rightAnswer = [];
        this.explanation = '';
        this.questionId = 0;
    }

     //alle Fragen (IDs), die im Spielverlauf bereits gestellt wurden, werden aus dem Sessionstorage geholt
    private getUsedQuestionIds(category: string): number[] {
        const key = `usedQuestionIds_${category}`;
        const data = sessionStorage.getItem(key);
        if (!data) return [];
        try {
            return JSON.parse(data) as number[];
        } catch {
            return [];
        }
    }

    //Speicherung der Fragen-ID, die im aktuellen Level gefragt werden wird
    private addUsedQuestionId(category: string, questionId: number): void {
        const key = `usedQuestionIds_${category}`;
        const usedIds = this.getUsedQuestionIds(category);
        if (!usedIds.includes(questionId)) {
            usedIds.push(questionId);
            sessionStorage.setItem(key, JSON.stringify(usedIds));
        }
    }

    //Auswahl einer noch nicht gestellten Frage
    private getNextUnusedQuestion<T extends { id: number }>(category: string, questionPool: T[], resetIfAllUsed = false): T | null {
        let usedIds = this.getUsedQuestionIds(category);
        let availableQuestions = questionPool.filter(q => !usedIds.includes(q.id));

        if (availableQuestions.length === 0) {
            if (resetIfAllUsed) {
                usedIds = [];
                sessionStorage.setItem(`usedQuestionIds_${category}`, JSON.stringify([]));
                availableQuestions = questionPool.slice();
            } else {
                return null;
            }
        }

        if (availableQuestions.length === 0) return null;

        const randomIndex = Math.floor(Math.random() * availableQuestions.length);
        const selectedQuestion = availableQuestions[randomIndex];

        if (!selectedQuestion) return null;

        this.addUsedQuestionId(category, selectedQuestion.id);
        return selectedQuestion;
    }

    //Laden der ausgewählten Frage
    loadQuestion(level: number) {
        return fetch('./fragen/questionpoolLine.json')
            .then(response => {
                if (!response.ok) throw new Error('Fehler beim Laden der JSON-Datei');
                return response.json();
            })
            .then((jsonData: Question[] | { questions: Question[] }) => {
                const questions = Array.isArray(jsonData) ? jsonData : jsonData.questions;

                //console.log('questions: ', questions);
                const levelQuestions = questions.filter(q => q.category === `Klasse ${level}` || !q.category); // Unterstützung für fehlendes "category"-Feld

                if (levelQuestions.length === 0) {
                    throw new Error(`Keine Fragen für Klasse ${level} gefunden`);
                }

                const question = this.getNextUnusedQuestion('line', levelQuestions);
                if (!question) throw new Error('Keine neuen Fragen verfügbar');

                this.questionText = question.text;
                this.options = question.options.map(opt => opt.text);
                this.rightAnswer = question.rightAnswer;
                this.explanation = question.explanation;
                this.questionId = question.id;

                const hint = new Hints(level, this.questionId);
                const hints = hint.getHints();

                return {
                    questionText: this.questionText,
                    options: this.options,
                    rightAnswer: this.rightAnswer,
                    explanation: this.explanation,
                    questionId: this.questionId,
                    hints,
                };
            });
    }

}

export default QuestionLoaderLine;
